import React from 'react';
import './Visitors.css';
import FMSimage from '../Assets/visitor1.png'; // First image (full size)
import FMSimage2 from '../Assets/visitor2.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/visitor3.webp'; // Image for How it Works section
import FMSimage4 from '../Assets/visitor4.jpeg'; // Image for Why Choose section
import FMSimage5 from '../Assets/visitor5.jpg'; // Image for Industries section

const FMS = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">VISITOR MANAGEMENT</h1>
                    <p className="FMS-description">
                        Our Visitor Management System (VMS) by Vajra IoT is designed to streamline the entire visitor experience from arrival to departure. With a focus on security, convenience, and efficiency, our solution ensures seamless check-ins, real-time monitoring, and instant visitor notifications. It integrates with building security systems and provides a secure, paperless check-in process, making it ideal for both corporate offices and industrial facilities.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Visitor Management" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Paperless Check-In:</strong> Visitors can check in using self-service kiosks or mobile devices, eliminating the need for physical sign-in sheets.</li>
                            <li><strong>Real-Time Notifications:</strong> Hosts are instantly notified of their visitor's arrival via email or mobile app notifications.</li>
                            <li><strong>Visitor Badge Printing:</strong> Generate custom visitor badges with details such as the visitor's name, photo, and host, ensuring security and easy identification.</li>
                            <li><strong>Integration with Access Control:</strong> The system integrates with building access control systems, enabling seamless entry for approved visitors.</li>
                            <li><strong>Enhanced Security:</strong> The system tracks visitor history and generates real-time reports for improved safety and security management.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Visitor Management Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Self-Service Kiosks:</strong> Visitors can easily check in using interactive kiosks or their own smartphones to quickly enter the premises.</li>
                            <li><strong>Host Notification:</strong> Upon check-in, the system automatically sends a notification to the host via email or app, ensuring they are aware of their visitor's arrival.</li>
                            <li><strong>Visitor Badge Generation:</strong> After check-in, a custom badge is printed with essential visitor details and an access pass for the duration of their visit.</li>
                            <li><strong>Access Control Integration:</strong> The system connects with your building's access control system to grant visitors entry to specific areas based on their approved access.</li>
                            <li><strong>Reporting & Analytics:</strong> Generate visitor reports and analyze visitor data to ensure better security management and operational efficiency.</li>
                        </ul>
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Visitor Management</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        <ul>
                            <li><strong>Improved Visitor Experience:</strong> Our user-friendly system ensures a smooth and efficient check-in process, enhancing the visitor experience from start to finish.</li>
                            <li><strong>Increased Security:</strong> Real-time tracking and automated alerts keep you informed about who is on-site at all times, increasing security and reducing risks.</li>
                            <li><strong>Customizable Features:</strong> Customize visitor badges, approval workflows, and access permissions to meet the unique needs of your organization.</li>
                            <li><strong>Cost Efficiency:</strong> Automating visitor management reduces administrative costs, saves time, and improves operational efficiency.</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our VMS */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our System</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using VMS" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Visitor Management System is trusted by numerous industries for its efficiency, security, and ease of use:
                        <ul>
                            <li>Corporate Offices</li>
                            <li>Healthcare Facilities</li>
                            <li>Educational Institutions</li>
                            <li>Government Buildings</li>
                            <li>Manufacturing Plants</li>
                            <li>Event Venues</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FMS;
